module.exports = __webpack_public_path__ + "img/MobileDefaultFeedbackPoor.80b6dad0.png";